import React from 'react';
import moment from 'moment/moment';

export function passStatusFormatter({ row, col }) {
  const pass = col.isNight ? row.night_lastPass : row.lastPass;
  if(!pass)
    return '';

  let text = passStatusText(pass.status);

  if(pass.status === 'canceled') {
    return text + ' ' + dateFormatter(pass.canceledAt);
  }

  return text;
}

passStatusFormatter.getRaw = (val) => passStatusText(val);


export function phoneFormatter({ row }) {
  return <a href={`tel://${row.phone}`}>{row.phone}</a>
}

phoneFormatter.getRaw = (val) => val;

export function passStatusText (status) {
  if(status === 'active') return 'Активный';
  if(status === 'expired') return 'Завершен';
  if(status === 'canceled') return 'АНУЛЛИРОВАН';
}

export function passDurationText(duration) {
  if(duration === 'year') return 'Годовой';
  if(duration === 'temp') return 'Разовый';
}

export function dateFormatter(time) {
  if(!time) {
    return '';
  }
  return moment(time).format('DD.MM.YYYY HH:mm');
}


export function formatPassTime({ col }) {
  return col.isNight ? 'Ночь' : 'День';
}

export function getPassClassName(pass) {
  if(!pass || pass.canceledAt > 0) {
    return 'ended';
  }

  const diff = -(Math.floor((Date.now() - pass.endsAt) / 1000));
  const gte = d => diff >= 86400 * d;

  let className;
  if(gte(60)) {
    className = 'ok';
  } else if(gte(4)) {
    className = 'warn';
  } else if(diff > 0) {
    className = 'ending';
  } else {
    className = 'ended';
  }

  return className;
}



// WEBPACK FOOTER //
// ./src/components/pages/clients/helpers.js